import store from '@/store';
import { IBusinessType } from '@/models/business';

import { ERouteDisclaimerMessage } from '../enums';
import { ValidatorState } from '../types';

export function birthdayClubValidator(): ValidatorState {
  const businessState = store.getters['business/getBusinessState'];

  if (!businessState) {
    return {
      isValid: false,
      disclaimersKeys: []
    };
  }

  const availableOperations = new Set([
    IBusinessType.BOTH,
    IBusinessType.INSTORE
  ]);
  const isValid =
    businessState.country === 'United States' &&
    availableOperations.has(businessState.type);

  let disclaimersKeys: Array<string> = [];

  if (!isValid) {
    disclaimersKeys.push(ERouteDisclaimerMessage.BIRTHDAY_CLUB_RESTRICTION);
  }

  return {
    isValid,
    disclaimersKeys
  };
}
